export const IS_DEVELOPMENT: boolean = ['development', 'test', 'staging'].indexOf((window as any).g_opt.env) !== -1;
